import { Fill, Stroke, Style } from 'ol/style';
import { Vector as VectorLayer } from 'ol/layer';
import { Vector as VectorSource } from 'ol/source';
import { GeoJSON } from 'ol/format';

export default {
  methods: {
    toggleBuffer(features) {
      this.getLayerById('buffer')
        ?.getSource()
        ?.clear();
      if (!features || features?.features?.length === 0) return;
      if (!this.getLayerById('buffer')) {
        const newLayer = new VectorLayer({
          id: 'buffer',
          isSpecial: true,
          zIndex: 999,
          opacity: 1,
          source: new VectorSource(),
          style: new Style({
            fill: new Fill({
              color: 'rgba(200, 0, 0, 0.6)',
            }),
            stroke: new Stroke({
              color: 'rgba(255, 0, 0, 1)',
              width: 2,
            }),
          }),
        });
        this.map.addLayer(newLayer);
      }
      this.getLayerById('buffer')
        .getSource()
        .addFeatures(
          new GeoJSON().readFeatures(features, {
            featureProjection: this.$_config.defaultEpsg || 'EPSG:4326',
            dataProjection: this.$_config.defaultEpsg || 'EPSG:4326',
          })
        );

      this.fitView(
        this.getLayerById('buffer')
          ?.getSource()
          ?.getExtent()
      );
    },
  },
  mounted() {
    this.$root.$off('toggleBuffer');
    this.$root.$on('toggleBuffer', this.toggleBuffer);
  },
};
